export default {
  accountConfig: (state) => {
    return state.accountConfig;
  },

  accountInfo: (state) => {
    return state.accountInfo;
  },
  accountInfoCode: (state) => {
    return state.accountInfoCode;
  },

  lastAccount: (state) => {
    return state.lastAccount;
  },

  voucherNoteType: (state) => {
    return state.voucherNoteType;
  },

  defaultVoucherDescription: (state) => {
    return state.defaultVoucherDescription;
  },

  financialRatio: (state) => {
    return state.financialRatio;
  },
  financialRatioItem: (state) => {
    return state.financialRatioItem;
  },

  numerator: (state) => {
    return state.numerator;
  },
  denominator: (state) => {
    return state.denominator;
  },

  vouchers: (state) => {
    return state.vouchers;
  },

  vouchersTotalCount: (state) => {
    return state.vouchersTotalCount;
  },

  voucherItem: (state) => {
    return state.voucher;
  },

  voucher: (state) => {
    if (
      !state.voucher ||
      !state.voucher.voucherDetails ||
      !state.accountInfo?.length
    )
      return null;
    return {
      ...state.voucher,
      voucherDetails: state.voucher.voucherDetails.map((z) => {
        const found = state.accountInfo.find((i) => i.id == z.accountInfoId);
        return {
          ...z,
          key: z.id,
          accountInfoTitle: found?.title || "",
          accountInfoCode: found?.code || "",
        };
      }),
    };
  },

  voucherNavigation: (state) => {
    state.voucherNavigation?.voucherDetails?.forEach(func);
    function func(item) {
      item.key = item.id;
    }
    return state.voucherNavigation;
  },

  voucherCheckCreate: (state) => {
    return state.voucherCheckCreate;
  },
  voucherCheckUpdate: (state) => {
    return state.voucherCheckUpdate;
  },

  voucherId: (state) => {
    return state.voucherId;
  },

  lastVoucherInfo: (state) => {
    return state.lastVoucherInfo;
  },

  voucherInfoDate: (state) => {
    return state.voucherInfoDate;
  },

  currentVoucherId: (state) => {
    return state.currentVoucherId;
  },

  voucherAttaches: (state) => {
    return state.voucherAttaches;
  },

  personCredits: (state) => {
    return state.personCredits;
  },

  userLimitAccounts: (state) => {
    return state.userLimitAccounts;
  },

  voucherNotes: (state) => {
    return state.voucherNotes;
  },

  confirmCartable: (state) => {
    return state.confirmCartable;
  },
  unConfirmCartable: (state) => {
    return state.unConfirmCartable;
  },

  voucherReview: (state) => {
    return state.voucherReview;
  },

  emptyVoucher: (state) => {
    return state.emptyVoucher;
  },

  archiveVoucher: (state) => {
    return state.archiveVoucher;
  },
  debtorOrCreditorDeclarations: (state) => {
    return state.debtorOrCreditorDeclarations;
  },
  debtorOrCreditorDeclaration: (state) => {
    return state.debtorOrCreditorDeclaration;
  },
  debtorOrCreditorDeclarationId: (state) => {
    return state.debtorOrCreditorDeclarationId;
  },

  debtorOrCreditorDeclarationCode: (state) => {
    return state.debtorOrCreditorDeclarationCode;
  },

  debtorOrCreditorDeclarationNavigation: (state) => {
    return state.debtorOrCreditorDeclarationNavigation;
  },

  debtorOrCreditorDeclarationCheckDelete: (state) => {
    return state.debtorOrCreditorDeclarationCheckDelete;
  },

  debtorOrCreditorDeclarationVoucher: (state) => {
    return state.debtorOrCreditorDeclarationVoucher;
  },

  voucherMaxCode: (state) => {
    return state.voucherMaxCode;
  },

  voucherMaxNumber: (state) => {
    return state.voucherMaxNumber;
  },

  voucherMaxTempNumber: (state) => {
    return state.voucherMaxTempNumber;
  },

  voucherVerification: (state) => {
    return state.voucherVerification;
  },

  generalJournalReport: (state) => {
    return state.generalJournalReport;
  },
  generalJournalSummaryReport: (state) => {
    return state.generalJournalSummaryReport;
  },

  accountOperationDetailReport: (state) => {
    return state.accountOperationDetailReport;
  },

  basedOnSaleManagerListReport: (state) => {
    return state.basedOnSaleManagerListReport;
  },
  reportOfCreditorsAndDebtorsBasedOnSalesManagers: (state) => {
    return state.reportOfCreditorsAndDebtorsBasedOnSalesManagers;
  },
  operationalLedgerAccountTurnoverReport: (state) => {
    return state.operationalLedgerAccountTurnoverReport;
  },
  personOperationDetailReport: (state) => {
    return state.personOperationDetailReport;
  },
  personOperationDetailSalt: (state) => {
    return state.personOperationDetailSalt;
  },
  trialBalance4ColumnsReport: (state) => {
    return state.trialBalance4ColumnsReport;
  },
  detailTrialBalance4ColumnsReport: (state) => {
    return state.detailTrialBalance4ColumnsReport;
  },
  trialBalance6ColumnsReport: (state) => {
    return state.trialBalance6ColumnsReport;
  },
  detailTrialBalance6ColumnsReport: (state) => {
    return state.detailTrialBalance6ColumnsReport;
  },
  trialBalance8ColumnsReport: (state) => {
    return state.trialBalance8ColumnsReport;
  },
  detailTrialBalance8ColumnsReport: (state) => {
    return state.detailTrialBalance8ColumnsReport;
  },
  accountWithPersonReport: (state) => {
    return state.accountWithPersonReport;
  },
  floatAccount1OperationDetail: (state) => {
    return state.floatAccount1OperationDetail;
  },
  floatAccount2OperationDetail: (state) => {
    return state.floatAccount2OperationDetail;
  },
  floatAccount3OperationDetail: (state) => {
    return state.floatAccount3OperationDetail;
  },
  floatAccount4OperationDetail: (state) => {
    return state.floatAccount4OperationDetail;
  },
  floatAccount5OperationDetail: (state) => {
    return state.floatAccount5OperationDetail;
  },
  floatAccountTextOperationDetail: (state) => {
    return state.floatAccountTextOperationDetail;
  },

  accountWithFloatAccount1: (state) => {
    return state.accountWithFloatAccount1;
  },
  accountWithFloatAccount2: (state) => {
    return state.accountWithFloatAccount2;
  },
  accountWithFloatAccount3: (state) => {
    return state.accountWithFloatAccount3;
  },
  accountWithFloatAccount4: (state) => {
    return state.accountWithFloatAccount4;
  },
  accountWithFloatAccount5: (state) => {
    return state.accountWithFloatAccount5;
  },
  accountWithFloatAccountText: (state) => {
    return state.accountWithFloatAccountText;
  },
  accountWithFloatAccountGroupReport: (state) => {
    return state.accountWithFloatAccountGroupReport;
  },

  floatAccount1WithPerson: (state) => {
    return state.floatAccount1WithPerson;
  },
  floatAccount2WithPerson: (state) => {
    return state.floatAccount2WithPerson;
  },
  floatAccount3WithPerson: (state) => {
    return state.floatAccount3WithPerson;
  },
  floatAccount4WithPerson: (state) => {
    return state.floatAccount4WithPerson;
  },
  floatAccount5WithPerson: (state) => {
    return state.floatAccount5WithPerson;
  },
  floatAccountTextWithPerson: (state) => {
    return state.floatAccountTextWithPerson;
  },

  floatAccount1WithAccount: (state) => {
    return state.floatAccount1WithAccount;
  },
  floatAccount2WithAccount: (state) => {
    return state.floatAccount2WithAccount;
  },
  floatAccount3WithAccount: (state) => {
    return state.floatAccount3WithAccount;
  },
  floatAccount4WithAccount: (state) => {
    return state.floatAccount4WithAccount;
  },
  floatAccount5WithAccount: (state) => {
    return state.floatAccount5WithAccount;
  },
  floatAccountTextWithAccount: (state) => {
    return state.floatAccountTextWithAccount;
  },
  statusDocumentReport: (state) => {
    return state.statusDocumentReport;
  },
  trialBalanceReport: (state) => {
    return state.trialBalanceReport;
  },

  personWithFloatAccount1: (state) => {
    return state.personWithFloatAccount1;
  },
  personWithFloatAccount2: (state) => {
    return state.personWithFloatAccount2;
  },
  personWithFloatAccount3: (state) => {
    return state.personWithFloatAccount3;
  },
  personWithFloatAccount4: (state) => {
    return state.personWithFloatAccount4;
  },
  personWithFloatAccount5: (state) => {
    return state.personWithFloatAccount5;
  },
  personWithFloatAccountText: (state) => {
    return state.personWithFloatAccountText;
  },
  electronicLedgerReport: (state) => {
    return state.electronicLedgerReport;
  },
  electronicLedgerExportData: (state) => {
    return state.electronicLedgerExportData;
  },

  personWithAccount: (state) => {
    return state.personWithAccount;
  },
  personCreditsReport: (state) => {
    return state.personCreditsReport;
  },
  personalAccountBalanceReport: (state) => {
    return state.personalAccountBalanceReport;
  },
  balanceReportPersonsList: (state) => {
    return state.balanceReportPersonsList;
  },
  personFinalVoucherReport: (state) => {
    return state.personFinalVoucherReport;
  },
  personOfficeReport: (state) => {
    return state.personOfficeReport;
  },
  personMultiLevelLedgerReport: (state) => {
    return state.personMultiLevelLedgerReport;
  },
  accountTreeReport: (state) => {
    return state.accountTreeReport;
  },
  floatAccount1BalanceReport: (state) => {
    return state.floatAccount1BalanceReport;
  },
  floatAccount2BalanceReport: (state) => {
    return state.floatAccount2BalanceReport;
  },
  floatAccount3BalanceReport: (state) => {
    return state.floatAccount3BalanceReport;
  },
  floatAccount4BalanceReport: (state) => {
    return state.floatAccount4BalanceReport;
  },
  floatAccount5BalanceReport: (state) => {
    return state.floatAccount5BalanceReport;
  },
  floatAccountTextBalanceReport: (state) => {
    return state.floatAccountTextBalanceReport;
  },
  reviewAccounts: (state) => {
    return state.reviewAccounts;
  },
  monthlyAccountingVoucherReport: (state) => {
    return state.monthlyAccountingVoucherReport;
  },
  monthlyAccountingVoucherExportData: (state) => {
    return state.monthlyAccountingVoucherExportData;
  },

  floatAccount1Office: (state) => {
    return state.floatAccount1Office;
  },
  floatAccount2Office: (state) => {
    return state.floatAccount2Office;
  },
  floatAccount3Office: (state) => {
    return state.floatAccount3Office;
  },
  floatAccount4Office: (state) => {
    return state.floatAccount4Office;
  },
  floatAccount5Office: (state) => {
    return state.floatAccount5Office;
  },
  floatAccountTextOffice: (state) => {
    return state.floatAccountTextOffice;
  },
  routeData: (state) => {
    return state.routeData;
  },

  finalizationDocument: (state) => {
    return state.finalizationDocument;
  },

  unFinalizationDocument: (state) => {
    return state.unFinalizationDocument;
  },

  profitAndLossIncomesReport: (state) => {
    return state.profitAndLossIncomesReport;
  },
  profitAndLossCostsReport: (state) => {
    return state.profitAndLossCostsReport;
  },
  balanceSheetReport: (state) => {
    return state.balanceSheetReport;
  },

  financialRatioReport: (state) => {
    return state.financialRatioReport;
  },

  voucherDetail: (state) => {
    return state.voucherDetail;
  },

  accountOfficeReport: (state) => {
    return state.accountOfficeReport;
  },

  printVoucherInfo: (state) => {
    return state.printVoucherInfo;
  },
  printLink: (state) => {
    return state.printLink;
  },
  printAccountOperationDetailReportInfo: (state) => {
    return state.printAccountOperationDetailReportInfo;
  },

  dashboardAccountOffice: (state) => {
    return state.dashboardAccountOffice;
  },
  dashboardAccountOfficeChart: (state) => {
    return state.dashboardAccountOfficeChart;
  },

  floatAccount1BalanceTreeReport: (state) => {
    return state.floatAccount1BalanceTreeReport;
  },

  floatAccount2BalanceTreeReport: (state) => {
    return state.floatAccount2BalanceTreeReport;
  },

  floatAccount3BalanceTreeReport: (state) => {
    return state.floatAccount3BalanceTreeReport;
  },

  floatAccount4BalanceTreeReport: (state) => {
    return state.floatAccount4BalanceTreeReport;
  },

  floatAccount5BalanceTreeReport: (state) => {
    return state.floatAccount5BalanceTreeReport;
  },
  floatAccountTextBalanceTreeReport: (state) => {
    return state.floatAccountTextBalanceTreeReport;
  },

  requiredDate: (state) => {
    return state.requiredDate;
  },

  closeAccountStep: (state) => {
    return state.closeAccountStep;
  },

  previewCloseTemporaryAccount: (state) => {
    return state.previewCloseTemporaryAccount;
  },

  previewClosePermanentAccount: (state) => {
    return state.previewClosePermanentAccount;
  },

  previewFinalDate: (state) => {
    return state.previewFinalDate;
  },

  isDeleteVoucher: (state) => {
    return state.isDeleteVoucher;
  },

  attachDetailVoucher: (state) => {
    return state.attachDetailVoucher;
  },

  voucherNotesReport: (state) => {
    return state.voucherNotesReport;
  },

  isError: (state) => {
    return state.isError;
  },

  accountCurrencyMonitoringProcess: (state) => {
    return state.accountCurrencyMonitoringProcess;
  },
  accountCurrencyMonitoringReport: (state) => {
    return state.accountCurrencyMonitoringReport;
  },
  accountCurrencyMonitoringReportDetail: (state) => {
    return state.accountCurrencyMonitoringReportDetail;
  },
  accountCurrencyTrialBalanceReport: (state) => {
    return state.accountCurrencyTrialBalanceReport;
  },
  accountCurrencyMonitoringNotProcessed: (state) => {
    return state.accountCurrencyMonitoringNotProcessed;
  },

  cartableLog: (state) => {
    return state.cartableLog;
  },

  voucherManagementCartable: (state) => {
    return state.voucherManagementCartable;
  },

  voucherMerge: (state) => {
    return state.voucherMerge;
  },
  voucherMergeDetails: (state) => {
    return state.voucherMergeDetails;
  },
  voucherMergeResult: (state) => {
    return state.voucherMergeResult;
  },

  // Static Getters ---------------------------------------------------------------
  voucehrOperationMenu() {
    return [
      {
        subItems: [{ value: 1, title: "مرتب سازی" }],
      },
      {
        subItems: [{ value: 2, title: "قطعی سازی/ لغو قطعی سازی" }],
      },
      {
        subItems: [{ value: 3, title: "بایگانی اسناد" }],
      },
    ];
  },
  filterVoucherOptions() {
    return [
      { value: 1, text: "تاریخ سند" },
      { value: 2, text: "شماره سند" },
    ];
  },
};
